import React from "react";

export default function Arrow({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14.401"
      viewBox="0 0 12 14.401"
      className={color}
    >
      <g id="triangle-sm-right" opacity="0.5">
        <g id="Group_334" dataName="Group 334">
          <path
            id="Path_143"
            dataName="Path 143"
            d="M18.436,12.183l-9.6-6A1.2,1.2,0,0,0,7,7.2v12a1.2,1.2,0,0,0,1.836,1.018l9.6-6a1.2,1.2,0,0,0,0-2.035Z"
            transform="translate(-7 -5.999)"
          />
        </g>
      </g>
    </svg>
  );
}
